<footer class="footer">
  <div class="container-fluid">
    <nav>
      <ul>
        <li>
          <a href="https://www.skylarkcontrol.com" target="_blank">
            About Us
          </a>
        </li>
      </ul>
    </nav>
    <div class="copyright">
      &copy;
      {{test | date: 'yyyy'}} <a href="https://www.skylarkcontrol.com" target="_blank">Skylark Control</a>
      <span class="build-stamp">{{ buildStamp }}</span>
    </div>
  </div>
</footer>